<template>
  <v-img src="/pafulab2.png" />
  <br>
  <div>
    本サイトは随時更新する予定です！
  </div>
  <br><br><br>
  <div>
    <a href="https://twitter.com/PafuOfDuck">開発者Twitter</a>
  </div>
</template>
  
<script>
</script>

<style scoped>
</style>